module.exports = __webpack_public_path__ + "img/arrow-right-circle.bcc8c510.svg";